import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  FormControl,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { openFormApi, submitFormApi } from "../../../Api";
import { getDisclaimerHtml } from "../../../Functions";

const FormContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  boxSizing: "border-box",
  maxHeight: "80vh",
  display: "flex",
  flexDirection: "column",
}));
const HeaderWrapper = styled(Box)(({ theme }) => ({
  position: "sticky",
  top: 0,
  zIndex: 2,
}));
const ButtonWrapper = styled(Box)(({ theme }) => ({
  position: "sticky",
  bottom: 0,
  paddingTop: theme.spacing(2),
  zIndex: 2,
  width: "100%",
}));
const FieldsWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  paddingTop: "12px",
  paddingBottom: "12px",
  paddingRight: "4px",
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "42px",
  color: "#fff",
  textAlign: "left",
  fontWeight: 500,
  fontFamily: "Open Sans",
  marginBottom: theme.spacing(2),
  textTransform: "uppercase",
  [theme.breakpoints.down("md")]: {
    fontSize: "30px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

const InputContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
}));

const FieldWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

const Label = styled(Typography)(({ theme }) => ({
  font: "normal normal 500 14px Poppins",
  color: "#fff",
  variant: "body1",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 500 14px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 500 14px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 500 14px Poppins",
  },
}));

const DescText = styled(Typography)(({ theme }) => ({
  font: "normal normal 500 14px Poppins",
  color: "#fff",
  variant: "body1",
  component: "span",
  marginBottom: "10px",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 500 12px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 500 12px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 500 12px Poppins",
  },
}));

const OutlinedInputComponent = styled(OutlinedInput)(({ theme }) => ({
  lineHeight: "16px",
  margin: 0,
  fontSize: "16px",
  color: "#fff",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  width: "100%",
  height: "40px",
  borderColor: theme.palette.primary.main,
  ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
    padding: "7px 16px",
  },
}));

const CountryCode = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 14px Open Sans",
  textAlign: "center",
  color: "#fff",
  vaiant: "h6",
  component: "p",
}));

const DisclaimerWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  columnGap: "10px",
  width: "100%",
  marginBottom: theme.spacing(2),
}));

const SubHeader = styled(Typography)(({ theme }) => ({
  font: "normal normal 500 12px Open Sans",
  textAlign: "left",
  color: "#fff",
  variant: "caption",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 500 8px Open Sans",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 500 10px Open Sans",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 500 12px Open Sans",
  },
}));
const ThankYouWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: theme.spacing(2),
  minHeight: "80vh"
}));
const ThankYouMessage = styled(Typography)(({ theme }) => ({
  font: "normal normal 600 24px Poppins",
  whiteSpace: "pre-line",
  textAlign: "left",
  color: "#fff",
  vaiant: "h6",
  component: "p",
}));
const FormComponent = ({ formState, contentState }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const [details, setDetails] = useState({});
  const [isCheckedDisclaimer, setIsCheckedDisclaimer] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const getLabelName = (meta) => {
    if (meta["required"] === true) {
      return `${meta["label"]}*`;
    } else {
      return meta["label"];
    }
  };

  const handleSubmit = async () => {
    let formData = { payload: { ...details } };
    if (details.hasOwnProperty("phone")) {
      formData["payload"]["phone"] = `+91-${details["phone"]}`;
    }
    if (details.hasOwnProperty("phone")) {
      formData["target"] = `+91-${details["phone"]}`;
    } else if (details.hasOwnProperty("email")) {
      formData["target"] = details["email"];
    } else {
      formData["target"] = "";
    }
    let response = await submitFormApi({
      formID: queryParams.get("form_id"),
      payload: formData,
    });
    setIsSubmitted(true);
  };

  const handleChange = (event) => {
    setDetails({ ...details, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    openFormApi({ formID: queryParams.get("form_id") });
  }, []);

  return (
    <>
      <FormContainer>

        {!isSubmitted ?
          <> <HeaderWrapper>
            <Title>{contentState.form_title}</Title>
          </HeaderWrapper>
            <InputContainer
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <FieldsWrapper>
                <Grid container rowSpacing={2}>
                  {formState.map((fieldMeta, index) => {
                    if (fieldMeta["field_type"] === "text") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              type="text"
                              name={fieldMeta["field_name"]}
                              autoComplete="off"
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "phone") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              name={fieldMeta["field_name"]}
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "^[0-9]{10}$",
                                maxLength: 10,
                              }}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              disabled={isSubmitted}
                              onChange={handleChange}
                              startAdornment={
                                <InputAdornment position="start">
                                  <CountryCode>+91</CountryCode>
                                </InputAdornment>
                              }
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "email") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              name={fieldMeta["field_name"]}
                              autoComplete="off"
                              type="email"
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              disabled={isSubmitted}
                              onChange={handleChange}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "integer") {
                      return (
                        <Grid item xs={12} sm={12} md={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              type="number"
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              disabled={isSubmitted}
                              onChange={handleChange}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "dropdown") {
                      return (
                        <Grid item xs={12}>
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                              <DescText>{fieldMeta.desc}</DescText>}

                            <FormControl fullWidth>
                              <Select
                                displayEmpty
                                input={
                                  <OutlinedInputComponent
                                    required={fieldMeta["required"]}
                                  />
                                }
                                MenuProps={{
                                  disableScrollLock: true,
                                  PaperProps: {
                                    sx: {
                                      bgcolor: "rgba(0, 0, 0, 0.9)",
                                      color: "#fff",
                                    },
                                  },
                                }}
                                sx={{
                                  height: "40px",
                                  color: "#fff",

                                  "& .MuiSelect-select": {
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "7px 16px",
                                    height: "40px",
                                    boxSizing: "border-box",
                                  },

                                  "& .MuiSelect-icon": {
                                    color: "#fff",
                                  },
                                }}
                                name={fieldMeta["field_name"]}
                                value={
                                  details.hasOwnProperty(fieldMeta["field_name"])
                                    ? details[fieldMeta["field_name"]]
                                    : ""
                                }
                                required={fieldMeta["required"]}
                                inputProps={{
                                  "aria-label": "Without label",
                                  style: { borderColor: "transparent" },
                                }}
                                onChange={handleChange}
                                disabled={isSubmitted}
                              >
                                {fieldMeta["inputs"].map((item) => (
                                  <MenuItem
                                    key={item}
                                    value={item}
                                    sx={{
                                      color: "#fff",
                                      font: "normal normal 400 14px Poppins",
                                    }}
                                  >
                                    {item}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </FieldWrapper>
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              </FieldsWrapper>
              <ButtonWrapper>
                <DisclaimerWrapper>
                  <FormControlLabel
                    disabled={isSubmitted}
                    sx={{
                      alignItems: "flex-start",
                      margin: 0,
                    }}
                    onChange={() => {
                      setIsCheckedDisclaimer(!isCheckedDisclaimer);
                    }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={isCheckedDisclaimer}
                        sx={{
                          paddingTop: "0px", color: "white"
                        }}
                      />
                    }
                    label={
                      <Box
                        sx={{
                          fontSize: "12px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                          margin: 0,
                          "& p": {
                            fontFamily: "inherit",
                            fontWeight: "inherit",
                            fontSize: "inherit",
                            margin: 0,
                          },
                          "& div": {
                            margin: 0,
                          },
                          //set font color to white for this template
                          color: "white",
                          "& *": {
                            color: "white !important",
                          },
                          "& a": {
                            color: "white !important",
                            textDecoration: "underline",
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: getDisclaimerHtml(contentState.disclaimer),
                        }}
                      />
                    }
                  />
                </DisclaimerWrapper>
                <Button
                  disabled={!isCheckedDisclaimer || isSubmitted}
                  variant="contained"
                  fullWidth
                  type="submit"
                  style={{
                    textTransform: "none",
                    color: !isCheckedDisclaimer || isSubmitted ? "gray" : "white",
                    border:
                      !isCheckedDisclaimer || isSubmitted
                        ? "1px solid gray"
                        : "none",
                    font: "normal normal 700 16px open sans",
                  }}
                >
                  SUBMIT
                </Button>
              </ButtonWrapper>
            </InputContainer>
          </>
          :
          <ThankYouWrapper>
            <ThankYouMessage>{contentState.thankyou_message}</ThankYouMessage>
          </ThankYouWrapper>}
      </FormContainer>
    </>
  );
};

export default FormComponent;
